export const colors = {
  transparent: 'transparent',
  black_100: '#25282b',
  black_80: '#52575c',
  black_70: '#727578',
  black_60: '#52575c',
  black_40: '#cacccf',
  black_20: '#dbdde0',
  black_10: '#ededed',
  black_5: '#f9f9fa',
  black: '#a0a4a8',
  gun_metal_100: '#383643',
  white: '#ffffff',
  primary_dark: '#EE5F27',
  primary: '#F2703D',
  primary_90: '#F6875B',
  primary_80: '#FF9A72',
  primary_70: '#FFA886',
  primary_60: '#FEB89D',
  primary_50: '#FFC8B3',
  primary_40: '#FECCB8',
  primary_30: '#FBC7B3',
  primary_20: '#FDC7B1',
  primary_10: '#FADFD4',
  primary_5: '#FFF2ED',
  secondary: '#004569',
  secondary_20: '#D9F3FF',
  secondary_30: '#4888A9',
  positive_default: '#2ac769',
  positive_dark: '#159348',
  positive_light: '#40dd7f',
  green_90: '#10773A',
  green_10: '#EEFFF5',
  positive_light_0: '#dff7e8',
  negative_default: '#fb4e4e',
  negative_dark: '#c10606',
  negative_light: '#ff6262',
  negative_20: '#fedcdc',
  negative_10: '#FFEDED',
  warning_dark: '#f6a609',
  warning_default: '#ffbc1f',
  warning_light: '#ffcb52',
  warning_20: '#fff5dd',
  warning_10: '#FFF8E8',
  negative_dark_0: '#bc3d3b',
  negative_dark_1: '#fb4b4b',
  purple: '#42307D',
  purple_25: '#FCFAFF',
  purple_50: '#a80092',
  purple_75: '#cc00b1',
  purple_100: '#F4EBFF',
  purple_800: '#53389E',
  purple_900: '#42307D',
  dark: '#000000',
  ag_primary: '#F2703D',
  ag_primary_dark: '#E05F2C',
  airbnb_primary: '#FF5A5F',
  airbnb_primary_dark: '#E05F2C',
};
